import React, { useContext, useEffect, useState } from "react";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import OfflineHeader from "../OfflineHeader/OfflineHeader";
import Button from "../../Helpers/Button/Button";
import trans from "../../../utils";
import AntdTable from "../../antd/Table/Table";
import { getAllData } from "../../../utils/IndexedDB";
import SnagHead from "./SnagHead";
import { popupcontext } from "../../../context/Popupscontext";
import Actions from "../../antd/Table/Actions";
import { Helmet } from "react-helmet";
import SnagOfflinePopup from "./SnagOfflinePopup/SnagOfflinePopup";
function BTN() {
	const navigate = useNavigate();
	return (
		<>
			<Button
				text={trans("Add New Snag")}
				onClick={() => navigate("/snag-offline-control")}
				type={"primary"}
			/>
		</>
	);
}
export default function Snag() {
	const [tableData, setTableData] = useState(null);
	const [configData, setConfigData] = useState(null);
	const [limit, setLimit] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const { deleted, setDeleted } = useContext(popupcontext);

	const fetchData = async () => {
		try {
			const data = await getAllData("OfflineModeData", "Snag");
			setTableData(data);
		} catch (error) {
			console.error("IndexedDB read error:", error);
		}
	};

	const fetchConfigData = async () => {
		try {
			const data = await getAllData("OfflineModeData", "configurationStore");
			setConfigData(data);
		} catch (error) {
			console.error("IndexedDB read error:", error);
		}
	};

	useEffect(() => {
		fetchData();
		fetchConfigData();
	}, []);

	useEffect(() => {
		if (deleted) {
			fetchData();
			setDeleted(false);
		}
	}, [deleted]);
	const statusColor = {
		"Pending Sync": `orange`,
		Synced: "green",
		Failed: "red",
		Syncing: "blue",
	};
	const SnagColumns = [
		{
			title: trans("Snag Number"),
			key: "id",
			dataIndex: "id",
			width: 200,
		},
		{
			title: trans("Project"),
			key: "project_name",
			dataIndex: "project_name",
			width: 200,
		},

		{
			title: trans("Building"),
			key: "zone_name",
			dataIndex: "zone_name",
			width: 200,
		},
		{
			title: trans("Level"),
			key: "level_name",
			dataIndex: "level_name",
			width: 200,
		},
		{
			title: trans("Space"),
			key: "room_name",
			dataIndex: "room_name",
			width: 200,
		},
		{
			title: trans("Sector"),
			dataIndex: "sector",
			key: "sector",
			width: 150,
			render: (_, record) => record?.snags?.[0]?.sector || "- - - - - - -",
		},
		// {
		// 	title: trans("Severity"),
		// 	key: "severity",
		// 	width: 150,
		// 	render: (_, record) =>
		// 		record?.snags?.length
		// 			? record.snags.map((snag, index) => (
		// 					<Tag
		// 						key={index}
		// 						color={
		// 							snag?.severity === "MINOR"
		// 								? "green"
		// 								: snag?.severity === "MAJOR"
		// 									? "yellow"
		// 									: snag?.severity === "CRITICAL"
		// 										? "red"
		// 										: "blue"
		// 						}
		// 					>
		// 						{trans(snag?.severity)}
		// 					</Tag>
		// 				))
		// 			: "-",
		// },
		{
			title: trans("Discipline"),
			key: "discipline",
			dataIndex: "discipline",
			width: 150,
			render: (discipline) => trans(discipline) || "- - - - - - -",
		},
		{
			title: trans("Status"),
			key: "status",
			dataIndex: "status",
			width: 150,
			render: (_, record) => {
				return (
					<Tag color={statusColor[record?.status] || "default"}>
						{trans(record?.status)}
					</Tag>
				);
			},
		},
		{
			title: trans("Actions"),
			key: "actions",
			fixed: "right",
			width: 120,
			render: (_, record) => {
				return (
					<Actions snagId={record.id} name={record.name} type="offlineMode" />
				);
			},
		},
	];
	const [query, setQuery] = useState("");

	const filteredData =
		tableData?.filter((item) => {
			const matchesConfig = configData?.some(
				(config) => config.name === item.configurationName,
			);
			if (!matchesConfig) return false;
			if (!query || !query.trim()) return true;
			return Object.values(item).some((value) =>
				String(value).toLowerCase().includes(query.toLowerCase()),
			);
		}) || [];

	const handleQueryChange = (e) => {
		// Handle both event objects and direct string values
		const newQuery = typeof e === "string" ? e : e?.target?.value || "";
		setQuery(newQuery);
		setCurrentPage(1);
	};
	return (
		<>
			<Helmet>
				<title>{trans("Snag List")}</title>
				<meta name="description" content={trans("Snag List")} />
			</Helmet>
			<OfflineHeader
				title={trans("Snag")}
				subTitle={trans(
					"You are working offline. Data will sync automatically when connection returns.",
				)}
				btn={BTN()}
				online={true}
			/>
			<SnagHead query={query} setQuery={handleQueryChange} />
			<div className="bg-white-rounded-top table-parent mt-2">
				<AntdTable
					columns={SnagColumns}
					dataSource={filteredData || []}
					loading={false}
					pageSize={limit}
					totalItems={filteredData?.length || 0}
					currentPage={currentPage}
					onPageChange={(page) => setCurrentPage(page)}
					onLimitChange={(newLimit) => {
						setLimit(newLimit);
						setCurrentPage(1);
					}}
				/>
			</div>
			<SnagOfflinePopup />
		</>
	);
}
